// extracted by mini-css-extract-plugin
export default {"overlay":"properties__overlay___X_1Od","controlRow":"properties__controlRow___pnBnZ","controlLabel":"properties__controlLabel___I9dMj"};